import { Theme } from '@mui/material';
import { Colors } from '@sweatpals/react-ui-kit';

export const userProfileMenuStyles = (theme: Theme) => ({
	paper: {
		mt: '15px',
		boxShadow: `0px 0px 8px 0px #38476D1F`,
		border: `1px solid ${Colors['2A2A2A']}`,
		borderRadius: '4px',
		minWidth: '250px',
		userSelect: 'none',
		backgroundColor: Colors['101010'],
		maxWidth: '250px',
		left: 'unset',
	},
	account: {
		display: 'flex',
		alignItems: 'center',
		gap: '10px',
		backgroundColor: Colors['1E1E1E'],
		p: '10px 8px',
	},
	accountTitle: {
		color: Colors.white_a50,
		fontFamily: 'Montserrat',
		fontSize: '10px',
		fontWeight: 500,
		lineHeight: '12px',
		letterSpacing: '0.08em',
		textTransform: 'uppercase',
	},
	accountName: {
		fontFamily: 'Montserrat',
		fontSize: '13px',
		fontWeight: 600,
		lineHeight: '21px',
		color: Colors.white,
	},
	accountIcon: {
		width: '18px',
		height: '18px',
		borderRadius: '50%',
		backgroundColor: Colors.white,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',

		'& svg': {
			width: '11px',
			height: '11px',
			color: Colors.black,
		}
	},
	menuItem: {
		p: '10px 16px',
		display: 'flex',
		alignItems: 'center',
		gap: '10px',
		fontFamily: 'Montserrat',
		fontSize: '14px',
		fontWeight: 600,
		lineHeight: '17px',
		color: Colors.white,
		cursor: 'pointer',
		borderBottom: `1px solid ${Colors.white_a5}`,

		'& svg': {
			width: '24px',
			height: '24px',
		},

		'&:last-child': {
			borderWidth: 0,
		},

		'&:hover': {
			backgroundColor: Colors['191919'],
		},
	},
});

